// extracted by mini-css-extract-plugin
export default {"excel-btn":"yield-accounting_excel-btn__T6sGI"};